import React from "react";
import AuditLogFeed from "./AuditLogFeed";
import {Box, Typography} from "@mui/material";
import {getAllAuditLogs} from "../api/AiAgentApi";

export function AuditLogsPage({ table_name, row_id }) {
    const [logs, setLogs] = React.useState([]);

    React.useEffect(() => {
        (async () => {
            const data = await getAllAuditLogs();
            setLogs(data);
        })();
    }, []);

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1.5 }}>
                История изменений
            </Typography>
            <AuditLogFeed logs={logs} />
        </Box>
    );
}
